import { useEffect, useRef, useState } from "react";

/** Recuadro para firmar con el dedo, el lápiz o el mouse. Devuelve la firma como PNG (data URL) o null si está vacío. */
export function FirmaPad({ alCambiar }: { alCambiar: (png: string | null) => void }) {
  const lienzo = useRef<HTMLCanvasElement>(null);
  const dibujando = useRef(false);
  const trazos = useRef(0);
  const [vacio, setVacio] = useState(true);

  useEffect(() => {
    const c = lienzo.current!;
    const escala = window.devicePixelRatio || 1;
    c.width = c.clientWidth * escala; c.height = c.clientHeight * escala;
    const ctx = c.getContext("2d")!;
    ctx.scale(escala, escala);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#13302A";
  }, []);

  const punto = (e: React.PointerEvent<HTMLCanvasElement>) => { const r = e.currentTarget.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top] as const; };
  function bajar(e: React.PointerEvent<HTMLCanvasElement>) {
    e.currentTarget.setPointerCapture(e.pointerId);
    dibujando.current = true;
    const ctx = e.currentTarget.getContext("2d")!; const [x, y] = punto(e);
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + 0.1, y + 0.1); ctx.stroke();
  }
  function mover(e: React.PointerEvent<HTMLCanvasElement>) {
    if (!dibujando.current) return;
    const ctx = e.currentTarget.getContext("2d")!; const [x, y] = punto(e);
    ctx.lineTo(x, y); ctx.stroke();
  }
  function subir() {
    if (!dibujando.current) return;
    dibujando.current = false; trazos.current++;
    setVacio(false);
    alCambiar(lienzo.current!.toDataURL("image/png"));
  }
  function borrar() {
    const c = lienzo.current!;
    c.getContext("2d")!.clearRect(0, 0, c.width, c.height);
    trazos.current = 0; setVacio(true); alCambiar(null);
  }
  return (
    <div className="firma">
      <canvas ref={lienzo} aria-label="Recuadro de firma" onPointerDown={bajar} onPointerMove={mover} onPointerUp={subir} onPointerLeave={subir} />
      <div className="fila" style={{ justifyContent: "space-between" }}>
        <span className="muted" style={{ fontSize: 13 }}>{vacio ? "Firme dentro del recuadro" : "Firma registrada"}</span>
        <button type="button" className="btn chico" onClick={borrar} disabled={vacio}>Borrar firma</button>
      </div>
    </div>
  );
}
